import { render, staticRenderFns } from "./CompanyOrdersTable.vue?vue&type=template&id=ef0582b4&"
import script from "./CompanyOrdersTable.vue?vue&type=script&lang=js&"
export * from "./CompanyOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/CompanyOrdersTable.vue
// module id = null
// module chunks = 